export const environment = {
    production: true,
    resourceProviderURI: 'https://pai-uat.ecosys.smilecdr.com/provider-fhir',
    crdFhirServer: 'https://pai-uat.ecosys.smilecdr.com/provider-fhir',
    payerFhirEndpoint: 'https://pai-uat.ecosys.smilecdr.com/payer-fhir',
    issuerURI: 'https://pai-uat.ecosys.smilecdr.com/smartauth',
    token_endpoint: 'https://pai-uat.ecosys.smilecdr.com/smartauth/oauth/token',
    clientId: 'dtr-facade',
    scopeUrl: 'openid patient/*.read patient/*.write profile launch/practitioner',
    dtrAppUrl: 'https://sof-uat.ecosys.smilecdr.com',
    cdsResourceProviderURI: 'https://pai-uat.ecosys.smilecdr.com/sof-fhir',
    cdsAppUrl: 'https://sof-uat.ecosys.smilecdr.com',
    payerGroupNpiSystem: "http://hl7.org/fhir/sid/us-npi",
    payerGroupNpiValue: "1356441356",
    coverageUrl: "Coverage?patient={{patientId}}&status=active",
};
